export default __webpack_public_path__ + "static/media/Bracers of the Living Tarim.1048b56f.jpg";